/**
 * Messages Preview Widget
 * Recent conversation previews with Ligio CTA.
 * Moved from StudentDashboardBeta (Phase 3.2 extraction).
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { MessageCircle } from 'lucide-react'
import { useTranslation } from '../../i18n/TranslationProvider'

export interface MessagesPreviewWidgetProps {
  className?: string
}

const dummyConversations = [
  { initial: 'S', name: 'Sarah Mitchell', preview: 'Great progress on paradiddles!', color: 'var(--color-cyan)' },
  { initial: 'M', name: 'Mark Johnson', preview: 'Recital registration confirmed', color: 'var(--color-amber-accent)' },
]

const MessagesPreviewWidget: React.FC<MessagesPreviewWidgetProps> = ({ className = '' }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div
      onClick={() => navigate('/dashboard/messages')}
      className={`bg-white border border-[var(--color-border-light)] rounded-[var(--radius-r)]
                  p-[18px] shadow-[var(--shadow-sh0)]
                  transition-all duration-[.2s]
                  cursor-pointer hover:shadow-[var(--shadow-sh2)] hover:-translate-y-[2px]
                  active:translate-y-0 active:scale-[.99]
                  flex flex-col ${className}`}
    >
      <div className="flex items-center gap-[7px] text-[11px] font-semibold text-[var(--color-text-tertiary)]
                      uppercase tracking-[.5px] mb-[12px]">
        <MessageCircle size={13} />
        {t('nav.messages', 'Messages')}
        <button
          onClick={(e) => { e.stopPropagation(); navigate('/dashboard/messages') }}
          className="ml-auto text-[10px] text-[var(--color-text-tertiary)] font-medium
                     hover:text-[var(--color-teal)] transition-colors duration-[.15s]"
        >
          2 new →
        </button>
      </div>
      {dummyConversations.map((conv, i) => (
        <div key={i} className="flex gap-[10px] py-[5px] items-start">
          <div
            className="w-[30px] h-[30px] rounded-full flex items-center justify-center text-[12px] text-white flex-shrink-0"
            style={{ background: conv.color }}
          >
            {conv.initial}
          </div>
          <div>
            <div className="text-[12px] font-bold text-[var(--color-text-primary)]">
              {conv.name}
            </div>
            <div className="text-[11px] text-[var(--color-text-tertiary)]">
              {conv.preview}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MessagesPreviewWidget
